import { TYPOGRAPHY_VARIANT, Typography } from '@tajawal/ct-web-design-system';
import Styled from './Warning.styled';

export type WarningProps = {
  message: string;
  testId: string;
  icon?: React.ReactNode;
};

function Warning({ message, testId, icon }: WarningProps): JSX.Element {
  return (
    <Styled.Wrapper data-testid={testId}>
      {icon}
      <Typography variant={TYPOGRAPHY_VARIANT.CAPTIONREG} component="p">
        {message}
      </Typography>
    </Styled.Wrapper>
  );
}

export default Warning;
